import {
  CategoriaResponseDto,
  PerfilInvestimentoResponseDto,
} from '../api/models/perfil-investimento-response.dto';
import { Perfil, PerfilCategoria, PerfilStatus } from '../models/perfil.model';

/** Converte o DTO da API no modelo de domínio consumido pela UI. */
export function mapPerfilInvestimentoDto(dto: PerfilInvestimentoResponseDto): Perfil {
  const idPerfil = dto.idPerfilInvestimento ?? dto.id ?? 0;

  return {
    id: idPerfil,
    nome: dto.nome ?? '',
    nomeExibicao: dto.nomeExibicao ?? '',
    descricao: dto.descricao ?? '',
    status: mapStatus(dto.status),
    ultimaAtualizacao: somenteData(dto.dataAtualizacao ?? dto.dataInclusao),
    // Respostas sem o campo (ex.: POST) mantêm o comportamento anterior: editável.
    permiteEdicao: dto.permiteEdicao ?? true,
    motivoBloqueioEdicao: dto.motivoBloqueioEdicao ?? '',
    categorias: (dto.categorias ?? []).map((categoria) =>
      mapCategoriaDto(categoria, idPerfil),
    ),
  };
}

export function mapCategoriaDto(
  dto: CategoriaResponseDto,
  idPerfilFallback: number,
): PerfilCategoria {
  return {
    idPerfilInvestimento: dto.idPerfilInvestimento ?? idPerfilFallback,
    idCategoria: dto.idCategoria ?? 0,
    nomePerfilInvestimento: dto.nomePerfilInvestimento ?? '',
    nomeCategoria: dto.nomeCategoria ?? '',
    cor: dto.cor ?? '',
    valorPercentual: dto.valorPercentual ?? 0,
    dataInclusao: somenteData(dto.dataInclusao),
    dataAtualizacao: somenteData(dto.dataAtualizacao),
  };
}

/** Converte o status da UI para o código esperado pelo backend (`A`/`I`). */
export function mapStatusToApi(status: PerfilStatus): 'A' | 'I' {
  return status === 'Ativo' ? 'A' : 'I';
}

/** Mantém apenas a parte `yyyy-MM-dd` de uma data/datetime ISO. */
function somenteData(valor: string | null | undefined): string {
  return (valor ?? '').split('T')[0];
}

/**
 * Aceita o código ('A'/'I') e a descrição ('Ativo'/'Inativo'), normalizados. Mesmo padrão de
 * `mapCodigoStatusToCampanhaStatus`.
 *
 * NOTE: o valor exato devolvido/esperado pelo backend ainda não foi
 * confirmado — aceitamos 'A'/'Ativo'. Ajustar se divergir.
 */
const PERFIL_STATUS_MAP: Record<string, PerfilStatus> = {
  A: 'Ativo',
  I: 'Inativo',
  ATIVO: 'Ativo',
  INATIVO: 'Inativo',
};

function mapStatus(status: string | null | undefined): PerfilStatus {
  const normalizado = (status ?? '').toString().trim().toUpperCase();
  return PERFIL_STATUS_MAP[normalizado] ?? 'Inativo';
}
